// Copyright 2017 Sorama B.V.

import { RecordingStep } from "datatypes/ScanStep";

export enum Corners {
    None,
    TopLeft,
    TopRight,
    BottomLeft,
    BottomRight,
}

export class StepsDescription {
    startCorner: Corners;
    widthInArrays: number;
    heightInArrays: number;
    strideDirection: string;
}

export class ScanPlannerExtension {
    public static generateStepsDescriptionFromSteps(steps: RecordingStep[]): StepsDescription {
        const result = new StepsDescription();

        const maxX: number = Math.max.apply(
            null,
            steps.map((x) => x.position.X)
        );
        const maxY: number = Math.max.apply(
            null,
            steps.map((x) => x.position.Y)
        );
        const minX: number = Math.min.apply(
            null,
            steps.map((x) => x.position.X)
        );
        const minY: number = Math.min.apply(
            null,
            steps.map((x) => x.position.Y)
        );

        result.heightInArrays = maxY - minY + 1;
        result.widthInArrays = maxX - minX + 1;

        if (steps.length > 1) {
            result.strideDirection = steps[0].position.X === steps[1].position.X ? "y" : "x";
        } else {
            result.strideDirection = "x";
        }

        // Determine Start corner. 0,0 is TopLeft
        if (steps[0].position.X === minX && steps[0].position.Y === minY) {
            result.startCorner = Corners.TopLeft;
        } else if (steps[0].position.X === minX) {
            result.startCorner = Corners.BottomLeft;
        } else if (steps[0].position.X === maxX && steps[0].position.Y === maxY) {
            result.startCorner = Corners.BottomRight;
        } else {
            result.startCorner = Corners.TopRight;
        }

        return result;
    }
}
